import { YouTubeVideo } from "./youtubeAdvanced";

export const dummyChannelVideos: YouTubeVideo[] = [
  {
    id: "v1",
    title: "How to Build a World-Class SaaS in 2026",
    description: "Learn the secrets of modern SaaS development using AI-driven workflows and advanced architecture.",
    thumbnail: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    publishedAt: new Date().toISOString(),
  },
  {
    id: "v2",
    title: "Groq vs. OpenAI: The Speed Revolution",
    description: "Deep dive into the performance of LPU technology and why it matters for your real-time applications.",
    thumbnail: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
    publishedAt: new Date(Date.now() - 86400000).toISOString(),
  },
  {
    id: "v3",
    title: "10 YouTube SEO Hacks for Micro-Channels",
    description: "Stop struggling with the algorithm. These 10 hacks will boost your impressions by 400%.",
    thumbnail: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&q=80",
    publishedAt: new Date(Date.now() - 172800000).toISOString(),
  }
];

export const dummyTrendingVideos: YouTubeVideo[] = [
  {
    id: "t1",
    title: "AI Agentic Coding: The Future of Software",
    description: "Trending in software development. 1.2M views.",
    thumbnail: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=800&q=80",
    publishedAt: new Date().toISOString(),
  },
  {
    id: "t2",
    title: "Sustainable Tech: Green Coding Practices",
    description: "Trending in technology. 850k views.",
    thumbnail: "https://images.unsplash.com/photo-1542601906-973ad1ee5f5e?w=800&q=80",
    publishedAt: new Date().toISOString(),
  }
];

export const dummyGroqSuggestion = {
  title: "🚀 CRUSH the Algorithm: The Ultimate SaaS Blueprint for 2026",
  description: "Are you ready to build something that lasts? In this video, we break down the 2026 SaaS Blueprint from zero to world-class. \n\nWhat you'll learn:\n✅ AI-Driven Workflows\n✅ Scaling with LPU Technology\n✅ The 'Creator Command Center' Architecture\n\n#SaaS #AI #Coding #SoftwareEngineering",
  tags: ["SaaS", "AI", "Startup", "Coding", "Groq", "Automation", "2026", "TechTrends"],
  reasoning: "The original title was too descriptive. The new title uses power words (CRUSH, Ultimate, Blueprint) and an emoji to increase CTR. The description is now structured with checkmarks for better readability and SEO keyword density."
};

export const dummyCompetitorVideos: (YouTubeVideo & { tags: string[] })[] = [
  {
    id: "cv1",
    title: "How I grew my YouTube channel to 100k in 30 days",
    description: "The complete strategy for viral growth. We talk about hooks, retention, and thumbnails.",
    thumbnail: "https://images.unsplash.com/photo-1496065187959-7f07b8353c55?w=800&q=80",
    publishedAt: new Date(Date.now() - 3600000).toISOString(),
    tags: ["growth", "viral", "strategy", "youtube", "100k"]
  },
  {
    id: "cv2",
    title: "My daily morning routine (minimalist)",
    description: "Watch how I start my day for maximum productivity and focus.",
    thumbnail: "https://images.unsplash.com/photo-1484417894907-623942c8ee29?w=800&q=80",
    publishedAt: new Date(Date.now() - 86400000).toISOString(),
    tags: ["lifestyle", "productivity", "morning", "routine"]
  }
];
